import { observable } from 'mobx';
//plugin
import axios from 'axios';
//config
import config from '../config'

class UserState {
  @observable login = false;

  handleLogout() {
    let self = this;
    axios.get(`${config.env.server}/api/logout`)
      .then((response) => response.data === 'logout'
        ? self.login = false
        : null
      )
      .catch((error) => console.log(error))
  }
  handleLogin() {
    let self = this;
    //Take credential from cocorobo.hk
    axios.defaults.withCredentials = true;
    axios.get(`${config.env.server}/api/state`).then((response) => {
      response.data === 'Logged' ? (self.login = true) : null
    }).catch((error) => console.log(error))
  }
}

var userState = new UserState;

export default userState;



// WEBPACK FOOTER //
// ./src/store/userState.js